import { render, staticRenderFns } from "./Form.General.vue?vue&type=template&id=03bf50ce"
import script from "./Form.General.vue?vue&type=script&lang=js"
export * from "./Form.General.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports